import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';
import { getScrollBarStyles } from '../../../../config/styles';
import { theme } from '../../../../styles/theme';

export const Menu = styled(Dropdown)`
  &&& {
    position: absolute !important;
    right: 4px;
    top: 4px;
    color: #8a94bd;
    font-size: 10px;
    border-radius: 3px;
    box-shadow: 0 0 0 1px #8a94bd;
    background-color: #ffffff;
    z-index: 15;
    max-height: 20px;

    color: #8a94bd;
    > span {
      display: inline-block;
      > svg {
        vertical-align: middle;
      }
    }
    &.active {
      color: #0076ea;
      > span {
        > svg {
          circle {
            fill: #0076ea;
          }
        }
      }
    }

    &&& > .menu {
      position: fixed;
      width: 140px;
      z-index: 16;
      overflow: visible;
      margin: 0 !important;
      left: ${(props) => props.right + 'px !important;'};
      top: ${({ top }) => (top ? `${top}px` : 'unset')}!important;
      bottom: ${({ bottom }) => (bottom ? `${bottom}px` : 'unset')}!important;
      padding: 4px 0;
      ${getScrollBarStyles(6)}

      .item {
        padding: 7px 12px !important;
      }
    }

    &.dropdown > div:hover > svg circle {
      fill: ${theme.colors.mainBlue};
    }
    &.dropdown.active > div > svg circle {
      fill: ${theme.colors.mainBlue};
    }
  }
`;
export const DropdownItem = styled(Dropdown.Item)`
  &&& {
    width: 140px !important;
    overflow: visible;

    padding: 7px 12px !important;

    .text {
      font: inherit;
      font-size: 14px;
      font-weight: 500;
      color: #8a94bd;
    }
  }
`;
